import React, { useEffect, useState } from 'react';
import Main from 'layouts/Main';
import Container from 'components/Container';
import GenericContent from './components/GenericContent';
import Hero from './components/Hero';
import GlobalSearchBar from './components/GlobalSearchBar';
import ContactLanding from '../Landing/components/ContactLanding/ContactLanding';
import SEO from 'components/SEO';
import InlineError from 'components/InlineError';
import config from '../../config/config';
import cmsClient from 'API/cmsClient';
import { ApiError } from 'types/apiError';

const MainPage = () => {
  const [main, setMain] = useState<any>(null);
  const [error, setError] = useState<ApiError | null>(null);

  const loadMain = () => {
    setError(null);
    cmsClient
      .get(
        '/api/main?populate[hero][populate][heroCarouselItems][populate]=*&populate[hero][populate]=background&populate[content][on][content.text-and-media][populate]=*&populate[content][on][content.carousel][populate][carouselItems][populate]=itemMedia&populate[content][on][content.certificates][populate]=certificates&populate[content][on][content.gallery][populate]=*&populate=SEO',
      )
      .then((response) => {
        setMain(response.data?.data || []);
      })
      .catch((err) => {
        setError(err as ApiError);
        setMain([]);
      });
  };

  useEffect(() => {
    loadMain();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const backgroundData = main?.hero?.background?.[0];
  let backgroundImage;

  if (backgroundData) {
    if (backgroundData.mime && backgroundData.mime.includes('svg')) {
      backgroundImage = backgroundData.url;
    } else {
      backgroundImage =
        backgroundData?.formats?.large?.url || backgroundData.url;
    }
  }

  const backgroundUrl = backgroundImage
    ? `${config.CMS_BASE_URL}${backgroundImage}`
    : '';
  return (
    <Main>
      {main && (
        <SEO
          title={main?.SEO?.MetaTitle}
          description={main?.SEO?.MetaDescription}
          keywords={main?.SEO?.MetaKeywords}
          url="/"
        />
      )}
      <Hero
        backgroundUrl={backgroundUrl}
        items={main?.hero?.heroCarouselItems}
      />
      <GlobalSearchBar />
      {error ? (
        <Container>
          <InlineError onRetry={loadMain} />
        </Container>
      ) : (
        <GenericContent content={main?.content} />
      )}
      <Container
        id="contact-section"
        sx={{
          '@media (min-width: 900px)': {
            paddingBottom: '150px',
          },
        }}
      >
        <ContactLanding sx={{ padding: 0 }} />
      </Container>
    </Main>
  );
};

export default MainPage;
